import { css } from '@lastbrand/web-ui-styled-system/css'

// DS twin of legacy `productTraditionalDiscountMessage.module.scss` (unguarded SCSS rendered the copy
// oversized under the DS 16px root). At the 11.11px root, 1.6rem/2.2rem ≈ 17.8px/24.4px -> body-18.
export const traditionalDiscountWrapperDsClass = css({
  marginTop: 'space-10', // legacy 1rem
  textStyle: 'body-18',
  color: 'black',
  display: 'flex',
  alignItems: 'center',
})

// Legacy `.infoIcon { margin-left: 0.4rem }`.
export const traditionalDiscountIconDsClass = css({
  marginLeft: 'space-4',
})
